import React, { useState } from 'react';
import { Col, Row, Checkbox, Switch } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

function SideContainer(props) {
  const [slide, setSlide] = useState(true);
  const [crime, setCrime] = useState(false);
  const [ancestry, setAncestry] = useState(false);
  const [race, setRace] = useState(false);
  const [income, setIncome] = useState(false);
  const [occupancy, setOccupancy] = useState(false);
  const [voting, setVoting] = useState(true);
  const [voting2024, setVoting2024] = useState(true);
  const [state, setState] = useState({
    crime: {on: false, progress: 55, property: true},
    race: {on: false, progress: 55},
    voting: {on: true, progress: 55},
    ancestry: {on: false, progress: 55},
    income: {on: false, progress: 55},
    occupancy: {on: false, progress: 55},
    voting2024: {on: true, progress: 55},
  });

  const setStateUpdate = (type, data) => {
    let st = {...state} 

    // Object.keys(st).map(key => {
    //   st[key].on = false
    // })
    // setCrime(false);
    // setAncestry(false);
    // setRace(false);
    // setIncome(false);
    // setOccupancy(false);
    // setVoting(false);

    let temp = st[type] ? st[type] : {};

    if (!temp.progress) {
      temp.progress = 100
    }

    temp = {...temp, ...data};
    let res = {};
    res[type] = temp;
    
    if (type == 'crime') {
      setCrime(res[type].on);
      setAncestry(false);
      setRace(false);
      setIncome(false);
      setOccupancy(false);
      setVoting(false);
      st['race']['on'] = false;
      st['voting']['on'] = false;
      st['voting2024']['on'] = false;
      st['ancestry']['on'] = false;
      st['income']['on'] = false;
      st['occupancy']['on'] = false;
    }
    if (type == 'ancestry') {
      setAncestry(res[type].on);
      setCrime(false);
      setRace(false);
      setIncome(false);
      setOccupancy(false);
      setVoting(false);
      st['crime']['on'] = false;
      st['voting']['on'] = false;
      st['voting2024']['on'] = false;
      st['race']['on'] = false;
      st['income']['on'] = false;
      st['occupancy']['on'] = false;
    }
    if (type == 'race') {
      setRace(res[type].on);
      setCrime(false);
      setAncestry(false);
      setIncome(false);
      setOccupancy(false);
      setVoting(false);
      st['crime']['on'] = false;
      st['voting']['on'] = false;
      st['voting2024']['on'] = false;
      st['ancestry']['on'] = false;
      st['income']['on'] = false;
      st['occupancy']['on'] = false;
    }
    if (type == 'income') {
      setIncome(res[type].on);
      setCrime(false);
      setAncestry(false);
      setRace(false);
      setOccupancy(false);
      setVoting(false);
      st['crime']['on'] = false;
      st['voting']['on'] = false;
      st['voting2024']['on'] = false;
      st['ancestry']['on'] = false;
      st['race']['on'] = false;
      st['occupancy']['on'] = false;
    }
    if (type == 'occupancy') {
      setOccupancy(res[type].on);
      setCrime(false);
      setAncestry(false);
      setRace(false);
      setIncome(false);
      setVoting(false);
      st['crime']['on'] = false;
      st['voting']['on'] = false;
      st['voting2024']['on'] = false;
      st['ancestry']['on'] = false;
      st['race']['on'] = false;
      st['income']['on'] = false;
    }
    if (type == 'voting') {
      setVoting(true);
      setVoting2024(true);
      setCrime(false);
      setAncestry(false);
      setRace(false);
      setIncome(false);
      setOccupancy(false);
      st['voting2024']['on'] = true;
      st['crime']['on'] = false;
      st['occupancy']['on'] = false;
      st['ancestry']['on'] = false;
      st['race']['on'] = false;
      st['income']['on'] = false;
    }
    if (type == 'voting2024') {
      setVoting(true);
      setVoting2024(res[type].on);
      setCrime(false);
      setAncestry(false);
      setRace(false);
      setIncome(false);
      setOccupancy(false);
      st['voting']['on'] = true;
      st['crime']['on'] = false;
      st['occupancy']['on'] = false;
      st['ancestry']['on'] = false;
      st['race']['on'] = false;
      st['income']['on'] = false;
    }
    temp = {...st, ...res};
    setState(temp);
    props.setState(temp);
  }

  return (
    <div>
      <Row
        style={{
          color: 'black',
          textAlign: 'left',
          lineHeight: '25px',
          overflowY: 'auto',
          height: 'calc(100vh - 100px)',
          backgroundColor: '#ffffff00',
          // boxShadow: '0px -2px 5px 0px #a3a3a3',
          // borderRadius: '10px',
          marginTop: '20px',
          marginRight: '10px',
          overflowX: 'hidden',
          paddingRight: '5px',
          paddingBottom: '10px',
          maxWidth: '100px',
          pointerEvents: 'auto'
        }}
        className="sidebar-menu"
      >
        <Col span={24} style={{marginLeft: 30}}>
          {slide ?
            <UpOutlined
              onClick={() => setSlide(false)}
              style={{fontSize: 30, fontWeight: 'bold'}}
            />
            :
            <DownOutlined
              onClick={() => setSlide(true)}
              style={{fontSize: 30, fontWeight: 'bold'}}
            />
            }
        </Col>
        {slide &&
          <>
            <Col className={`option-image-section ${voting ? 'selected' : ''}`} span={24}>
              <div onClick={() => setStateUpdate('voting', {on: true})}>
                <div className='flex'>
                  <div className={`option-title title-light`}>Voting</div>
                </div>
                <div>
                  <img src="../img/Voting_g.png" className={`option-image ${voting ? 'hide' : ''}`}/>
                  <img src="../img/Voting_o.png" className={`option-image ${!voting ? 'hide' : ''}`}/>
                </div>
              </div>
              <div className='voting-elem'>
                <Switch
                  className='mt-2'
                  checked={voting2024}
                  defaultChecked
                  onChange={(e) => setStateUpdate('voting2024', {on: e})}
                />
                <div className='voting-label'>
                  <div className={`year-title title-light`}>2020</div>
                  <div className={`year-title title-light`}>2024</div>
                </div>
              </div>
            </Col>
            <Col className={`option-image-section ${income ? 'selected' : ''}`} span={24} onClick={() => setStateUpdate('income', {on: !income})}>
              <div className='flex'>
                <div className={`option-title title-light`}>Income</div>
                {/* <Switch
                  className='mt-2'
                  checked={income}
                  onChange={(e) => setStateUpdate('income', {on: e})}
                /> */}
              </div>
              <div>
                <img src="../img/Income_g.png" className={`option-image ${income ? 'hide' : ''}`}/>
                <img src="../img/Income_o.png" className={`option-image ${!income ? 'hide' : ''}`}/>
              </div>
            </Col>
            <Col className={`option-image-section ${ancestry ? 'selected' : ''}`} span={24} onClick={() => setStateUpdate('ancestry', {on: !ancestry})}>
              <div className='flex'>
                <div className={`option-title title-light`}>Ancestry</div>
                {/* <Switch
                  className='mt-2'
                  checked={ancestry}
                  onChange={(e) => setStateUpdate('ancestry', {on: e})}
                /> */}
              </div>
              <div>
                <img src="../img/Ancestry_g.png" className={`option-image ${ancestry ? 'hide' : ''}`}/>
                <img src="../img/Ancestry_o.png" className={`option-image ${!ancestry ? 'hide' : ''}`}/>
              </div>
            </Col>


            <Col className={`option-image-section ${race ? 'selected' : ''}`} span={24} onClick={() => setStateUpdate('race', {on: !race})}>
              <div className='flex'>
                <div className={`option-title title-light`}>Race</div>
                {/* <Switch
                  className='mt-2'
                  checked={race}
                  onChange={(e) => setStateUpdate('race', {on: e})}
                /> */}
              </div>
              <div>
                <img src="../img/Race_g.png" className={`option-image ${race ? 'hide' : ''}`}/>
                <img src="../img/Race_o.png" className={`option-image ${!race ? 'hide' : ''}`}/>
              </div>
            </Col>
            <Col className={`option-image-section ${occupancy ? 'selected' : ''}`} span={24}
              onClick={() => setStateUpdate('occupancy', {on: !occupancy})}
            >
              <div className='flex'>
                <div className={`option-title title-light`} style={{fontSize: '13px', lineHeight: '17px'}}>Household<br/>Size</div>
                {/* <Switch
                  className='mt-2'
                  checked={occupancy}
                  onChange={(e) => setStateUpdate('occupancy', {on: e})}
                /> */}
              </div>
              <div>
                <img src="../img/Household_g.png" className={`option-image ${occupancy ? 'hide' : ''}`}/>
                <img src="../img/Household_o.png" className={`option-image ${!occupancy ? 'hide' : ''}`}/>
              </div>
            </Col>
            <Col className={`option-image-section ${crime ? 'selected' : ''}`} span={24} onClick={() => setStateUpdate('crime', {on: !crime})}>
              <div className='flex'>
                <div className={`option-title title-light`}>Crime</div>
                {/* <Switch
                  defaultChecked
                  checked={crime}
                  onChange={(e) => setStateUpdate('crime', {on: e})}
                /> */}
                
              </div>
              <div>
                <img src="../img/Crime_g.png" className={`option-image ${crime ? 'hide' : ''}`}/>
                <img src="../img/Crime_o.png" className={`option-image ${!crime ? 'hide' : ''}`}/>
                <Checkbox
                  className='mt-2'
                  onChange={(e) => setStateUpdate('crime', {property: e.target.checked})}
                  defaultChecked={true}
                >
                  <span className={`option-title title-light`} style={{fontSize: '12px'}}>Property</span>
                </Checkbox>
              </div>
            </Col>
          </>
        }
      </Row>
    </div>
  );
}

export default SideContainer;